import {useEffect, useState} from 'react';
import styles from './ReportSource.module.css';
import {IReportAction, TableRow} from "../../types/types.table.ts";
import {postUser} from "../../helper/http.ts";

interface AppBarProps {
  action: IReportAction;
  row: TableRow;
  result: string;
}


export default function ReportSource({
    action,
    row,
    result
}: AppBarProps) {
    return <pre className={styles.pre}>{result}</pre>;
}